import React, { useState, useCallback, useEffect, forwardRef } from 'react';
import Textarea from '@mui/joy/Textarea';
import FormControl from '@mui/joy/FormControl';
import Button from '@mui/joy/Button';
import Typography from '@mui/joy/Typography';


//////////////// Alert
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

///////////////// Use Form
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';


import { getSettings, updateSettings } from '../../Api/common';

const schema = yup.object({
    terms_ar: yup.string().required("هذا الحقل مطلوب"),
    terms_en: yup.string().required("هذا الحقل مطلوب"),

})


const Alert = forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});


export default function TermsAndConditionsComponent() {
    const [content, setContent] = useState(null)
    const [loading, setLoading] = useState(false)
    const [openAlert, setOpenAlert] = useState(false);
    const [messageAlert, setMessageAlert] = useState('');

    const [openAlertError, setOpenAlertError] = useState(false);
    const [messageAlertError, setMessageAlertError] = useState('');

    const form = useForm({
        defaultValues: {
            terms_ar: "",
            terms_en: "",
        },
        resolver: yupResolver(schema)
    });
    const { register, handleSubmit, formState, setValue } = form;
    const { errors } = formState


    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false);
    };

    const handleCloseAlertError = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlertError(false);
    };


    const getAllContent = useCallback(async () => {
        const res = await getSettings()
        if (res) {
            setValue('terms_ar', res.terms_ar)
            setValue('terms_en', res.terms_en)
        }
    }, []);

    const submitcontent = async (data) => {
        setLoading(true)
        try {
            const res = await updateSettings(data)
            if (res) {
                setOpenAlert(true)
                setMessageAlert("تم تعديل محتوى الشروط والاحكام بنجاح")
                setLoading(false)
                getAllContent();
            }
        } catch (error) {
            if (error.response) {
                setLoading(false)
                setOpenAlertError(true)
                setMessageAlertError(error.response.data.message)
            }
        }
    }

    useEffect(() => {
        getAllContent();
    }, [getAllContent])

    return (
        <>
            <Snackbar open={openAlert} autoHideDuration={6000} onClose={handleClose}>
                <Alert severity="success">{messageAlert}</Alert>
            </Snackbar>

            <Snackbar open={openAlertError} autoHideDuration={6000} onClose={handleCloseAlertError}>
                <Alert onClose={handleCloseAlertError} severity="warning" sx={{ width: '100%' }}>
                    {messageAlertError}
                </Alert>
            </Snackbar>
            <form onSubmit={handleSubmit(submitcontent)}>

                <FormControl>
                    <Textarea
                        placeholder="الشروط و الاحكام"
                        minRows={10}
                        sx={{
                            '--Textarea-focusedInset': 'var(--any, )',
                            '--Textarea-focusedThickness': '0.25rem',
                            '--Textarea-focusedHighlight': 'rgba(13,110,253,.25)',
                            '&::before': {
                                transition: 'box-shadow .15s ease-in-out',
                            },
                            '&:focus-within': {
                                borderColor: '#E6E6E6',
                            },
                            background: '#F7F9FB',
                            marginBottom: '20px'
                        }}
                        {...register('terms_ar')}
                    />
                    {errors.terms_ar &&
                        <Typography
                            color="danger"
                            level="body-xs"
                            variant="plain"
                        >{errors.terms_ar?.message}</Typography>
                    }
                </FormControl>

                <FormControl sx={{direction:'ltr'}}>
                    <Textarea
                        placeholder="terms and conditions"
                        minRows={10}
                        sx={{
                            '--Textarea-focusedInset': 'var(--any, )',
                            '--Textarea-focusedThickness': '0.25rem',
                            '--Textarea-focusedHighlight': 'rgba(13,110,253,.25)',
                            '&::before': {
                                transition: 'box-shadow .15s ease-in-out',
                            },
                            '&:focus-within': {
                                borderColor: '#E6E6E6',
                            },
                            background: '#F7F9FB',
                            marginBottom: '20px'
                        }}
                        {...register('terms_en')}
                    />
                    {errors.terms_en &&
                        <Typography
                            color="danger"
                            level="body-xs"
                            variant="plain"
                        >{errors.terms_en?.message}</Typography>
                    }
                </FormControl>

                <Button
                    variant='solid'
                    type='submit'
                    loading={loading}
                    sx={{ marginTop: '30px', backgroundColor: '#3E64F4', color: '#FFF', height: '60px', borderRadius: '30px' }}>
                    تجديد المحتوى
                </Button>
            </form>
        </>
    )
}